module.exports = __webpack_public_path__ + "img/home_intellimat.a06a5670.jpg";